import React from 'react';
import { ArcBox, ArcStack, ArcText } from '@src/core/ui';

interface RecordingIndicatorProps {
  isRecording: boolean;
  onClick?: () => void;
}

const RecordingIndicator: React.FC<RecordingIndicatorProps> = ({ isRecording, onClick }) => {
  return (
    <ArcStack
      top={10}
      left={10}
      zIndex={100}
      spacing={0.75}
      direction='row'
      alignItems='center'
      position='absolute'
      onClick={onClick}
      sx={{
        px: 1,
        py: 0.375,
        borderRadius: 1,
        bgcolor: 'common.white',
        cursor: onClick ? 'pointer' : 'default',
      }}>
      <ArcBox
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          bgcolor: isRecording ? 'error.main' : 'grey.400',
          border: '2px solid',
          borderColor: isRecording ? 'error.dark' : 'grey.500',
          ...(isRecording && {
            animation: 'pulse 1.5s ease-in-out infinite',
            '@keyframes pulse': {
              '0%, 100%': { opacity: 1 },
              '50%': { opacity: 0.4 },
            },
          }),
        }}
      />
      <ArcText.caption sx={{ color: 'common.black', fontWeight: 600 }}>
        Rec
      </ArcText.caption>
    </ArcStack>
  );
};

export default RecordingIndicator;
